import { request } from '../api'

export const useLoginApi = () => {
  const api = useEnvApi()

  const invokeV3 = async (route: string, data: Record<string, any> = {}) => {
    const response = await request({
      baseURL: api.homeClient,
      url: `${WIKIBITWEBV1}/invoke-v3/v3`,
      method: 'POST',
      data,
      headers: {
        Routes: route,
      },
    })

    return response as any
  }

  const getUserCookie = async (data: Record<string, any> = {}) => {
    const response = await request({
      baseURL: api.homeClient,
      url: `${WIKIBITWEBV1}/usercenter/cookie/getcookie-v1`,
      method: 'POST',
      data,
    })

    return response as any
  }

  const getUserFromCookie = async (params: Record<string, any> = {}) => {
    const response = await request({
      baseURL: api.homeClient,
      url: `${WIKIBITWEBV1}/usercenter/cookie/getuserfromcookie-v1`,
      method: 'GET',
      params,
    })

    return response as any
  }

  return {
    getUserCookie,
    getUserFromCookie,
    invokeV3,
  }
}
